import React from 'react';
import SVGImage from '../layout/SVGImage';

interface PowerOutageScheduleErrorMessageProps {
  testId?: string;
  className?: string;
  text?: string | null;
}

export const PowerOutageScheduleErrorMessage: React.FC<
  PowerOutageScheduleErrorMessageProps
> = ({ testId, className, text }) => {
  return (
    <div
      data-testid={testId}
      className={`noto-normal-3 flex h-[22px] w-full items-center justify-center rounded-[5px] bg-[#FFB9B9] text-[#7C0204] ${className}`}
    >
      <SVGImage name="warning" className="mr-1" />
      {text}
    </div>
  );
};
